import { Component } from '@angular/core';

@Component({
  selector: 'app-welcome-email',
  standalone: true,
  imports: [],
  templateUrl: './welcome-email.component.html',
  styleUrl: './welcome-email.component.scss'
})
export class WelcomeEmailComponent {
  companyName = 'arq-it';
  tagline = 'Construyendo experiencias memorables';
  websiteUrl = 'https://www.dev.arq-it.cl';
}
